import React from 'react';
import './typing-indicator.css';

const TypingIndicator = () => {
  return (
    <div className="typing-indicator" aria-label="Loading response">
      <span className="typing-dot" />
      <span className="typing-dot" />
      <span className="typing-dot" />
    </div>
  );
};

export default TypingIndicator;
